export const UNCONFIRMED_SEND_WARNING = "The previous email's delivery could not be confirmed. Sending again may result in the recipient receiving another copy.";
